export const COOKIES = {
  nrep_pt_ue: 'nrep_pt_ue',
  nrep_onboarded: 'nrep_onboarded',
  nrep_tours_requested: 'nrep_tours_requested',
}
